import React from 'react';
import Text from 'admin/components/common/Text';
import { FontSize } from 'admin/components/common/Text/config';

export const PageTitle: React.FC<{
	className?: string;
	text?: React.ReactNode;
	size?: (typeof FontSize)[keyof typeof FontSize];
}> = props => {
	return (
		<Text
			tag="h1"
			size={props.size ? props.size : 'pageTitle'}
			weight={Text.weight.normal}
			className={props.className}
		>
			{props.text}
		</Text>
	);
};

export default PageTitle;
